import { useUser } from '@client/hooks/business/user/useUser';
import { CORE_SYSTEM_ROLES, ORG_ROLES, type Role } from '@shared/constants';

export function isTrainingManagerOnlyUser(roles: readonly Role[]): boolean {
    return (
        roles.includes(ORG_ROLES.TRAINING_MANAGER) &&
        !roles.some((role) => (CORE_SYSTEM_ROLES as readonly Role[]).includes(role))
    );
}

/**
 * Returns true if the current user has the training_manager role
 * but none of the core system roles (org_admin, user_manager, user, shared_edit_user).
 *
 * Used to show a stripped-down system experience focused on training management.
 */
export function useIsTrainingManagerOnly(): boolean {
    const user = useUser({ throwOnUndefined: false });
    if (!user) return false;
    return isTrainingManagerOnlyUser(user.roles);
}
